import { NavLink, Outlet } from 'react-router-dom';

import { useEspace } from '../data/espace-context';
import { Cloche } from '../notifications/Cloche';
import './application-shell.css';
import { navItems } from './nav-items';
import { useCompteurDecisions } from './use-compteur-decisions';

function Badge({ valeur }: { valeur: number }) {
  if (valeur <= 0) return null;
  return (
    <span className="shell__badge" aria-label={`${valeur} à décider`}>
      {valeur > 99 ? '99+' : valeur}
    </span>
  );
}

export function ApplicationShell() {
  const aDecider = useCompteurDecisions();
  const { monMembre } = useEspace();
  const monMembreId = monMembre?.id ?? null;
  return (
    <div className="shell">
      <a className="skip-link" href="#shell-main">
        Aller au contenu
      </a>
      <aside className="shell__sidebar">
        <div>
          <div className="shell__marque">
            <p className="shell__brand">ALBA</p>
            <div className="cloche--sombre">
              <Cloche monMembreId={monMembreId} />
            </div>
          </div>
          <nav className="shell__nav" aria-label="Navigation principale">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  isActive ? 'shell__nav-link active' : 'shell__nav-link'
                }
              >
                <span aria-hidden="true">{item.icon}</span>
                {item.label}
                {item.to === '/a-decider' && <Badge valeur={aDecider} />}
              </NavLink>
            ))}
          </nav>
        </div>
        <NavLink to="/compte" className="shell__account">
          Mon compte
        </NavLink>
      </aside>
      <div className="shell__topbar">
        <Cloche monMembreId={monMembreId} />
        <NavLink
          to="/compte"
          className="shell__account shell__account--on-canvas"
          aria-label="Mon compte"
        >
          Mon compte
        </NavLink>
      </div>
      <main id="shell-main" className="shell__main">
        <Outlet />
      </main>
      <nav className="shell__tabbar" aria-label="Navigation principale">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              isActive ? 'shell__tabbar-link active' : 'shell__tabbar-link'
            }
          >
            <span className="shell__tabbar-icon" aria-hidden="true">
              {item.icon}
              {item.to === '/a-decider' && <Badge valeur={aDecider} />}
            </span>
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
